import PropTypes from "prop-types";
import React from "react";

const ScarcityMessaging = ({productDescriptorCount}) => {
  const displayScarcityMessaging = productDescriptorCount > 0 && productDescriptorCount < 3;

  return (
    <div>
      {displayScarcityMessaging &&
        <div className="scarcity-messaging">
          <div className="icon scarcity-icon" />
          <div className="scarcity-message">
            {`Low stock - only ${productDescriptorCount} left`}
          </div>
        </div>
      }
    </div>
  );
};


ScarcityMessaging.propTypes = {"productDescriptorCount": PropTypes.number};
ScarcityMessaging.defaultProps = {"productDescriptorCount": null};

export default ScarcityMessaging;
